import React from 'react'
import {
  Mail,
  Phone,
  MapPin,
  Facebook,
  Youtube,
  Globe,
  Heart,
  GraduationCap,
  Sparkles
} from 'lucide-react'

const Footer: React.FC = () => {
  return (
    <footer className="bg-gradient-to-r from-slate-700 to-slate-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Logo và thông tin chính */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="/AI-PhysicsBook.png"
                alt="AI-PhysicsBook"
                className="w-12 h-12 object-contain"
              />
              <div>
                <h3 className="text-2xl font-bold text-gray-200">AI-PhysicsBook</h3>
                <p className="text-gray-300">Learn Smarter with AI Interactive Ebook</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Nền tảng học tập vật lí hiện đại với mô phỏng tương tác,
              trắc nghiệm thông minh và hỗ trợ học offline.
            </p>
          </div>

          {/* Thông tin giáo viên */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-gray-200 flex items-center">
              <GraduationCap className="w-5 h-5 mr-2 text-blue-300" />
              Thông tin giáo viên
            </h4>
            <div className="space-y-3 text-sm">
              <div>
                <p className="font-medium text-gray-200">Thầy Trần Quốc Quân</p>
                <p className="text-gray-300">Giáo viên Trường THPT Tây Sơn, Gia Lai</p>
              </div>

              <div className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 text-blue-300 mt-0.5 flex-shrink-0" />
                <span className="text-gray-300">Bình An - Gia Lai</span>
              </div>

              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-blue-300" />
                <a
                  href="tel:0978531191"
                  className="text-gray-300 hover:text-gray-200"
                >
                  0978531191
                </a>
              </div>

              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-blue-300" />
                <a
                  href="mailto:quants82@gmail.com"
                  className="text-gray-300 hover:text-gray-200"
                >
                  quants82@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* Liên kết mạng xã hội */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-gray-200">Kết nối với chúng tôi</h4>
            <div className="space-y-3">
              <a
                href="https://www.facebook.com/quants82"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-gray-300 hover:text-gray-200 group"
              >
                <div className="w-8 h-8 bg-[#1877F2] rounded-full flex items-center justify-center group-hover:bg-[#166FE5] transition-colors">
                  <Facebook className="w-4 h-4 text-white" />
                </div>
                <span className="text-sm text-gray-200">Facebook</span>
              </a>

              <a
                href="https://www.youtube.com/@vatli365"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-gray-300 hover:text-gray-200 group"
              >
                <div className="w-8 h-8 bg-[#FF0000] rounded-full flex items-center justify-center group-hover:bg-[#E60000] transition-colors">
                  <Youtube className="w-4 h-4 text-white" />
                </div>
                <span className="text-sm text-gray-200">YouTube</span>
              </a>

              <a
                href="https://vatli365.vn/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-gray-300 hover:text-gray-200 group"
              >
                <div className="w-8 h-8 bg-[#34A853] rounded-full flex items-center justify-center group-hover:bg-[#2E8B47] transition-colors">
                  <Globe className="w-4 h-4 text-white" />
                </div>
                <span className="text-sm text-gray-200">Website</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bản đồ trường */}
        <div className="mt-10 mb-2">
          <p className="text-sm font-semibold text-gray-300 mb-3 flex items-center gap-1">
            <MapPin className="w-4 h-4 text-blue-300" /> Vị trí trường
          </p>
          <div className="rounded-xl overflow-hidden border border-slate-500">
            <iframe
              src="https://maps.google.com/maps?q=Trường+THPT+Tây+Sơn,+Bình+An,+Gia+Lai,+Việt+Nam&output=embed&hl=vi&z=15"
              width="100%" height="260" style={{border:0}} loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Vị trí Trường THPT Tây Sơn, Bình An, Gia Lai"
            />
          </div>
        </div>

        {/* Đường phân cách */}
        <div className="border-t border-slate-500 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-300">
              © 2025 <span className="text-gray-200 font-medium">AI-PhysicsBook</span>.
              Tất cả quyền được bảo lưu.
            </div>

            <div className="text-sm text-gray-400 flex items-center">
              <Sparkles className="w-4 h-4 mr-1 text-yellow-500" /> bởi AI-PhysicsBook
            </div>

            <div className="flex items-center space-x-6 text-sm">
              <a href="/gioi-thieu" className="text-gray-300 hover:text-gray-200">
                Giới thiệu
              </a>
              <a href="/chinh-sach-bao-mat" className="text-gray-300 hover:text-gray-200">
                Chính sách bảo mật
              </a>
              <a href="#" className="text-gray-300 hover:text-gray-200">
                Điều khoản sử dụng
              </a>
              <a href="tel:0978531191" className="text-gray-300 hover:text-gray-200">
                Liên hệ
              </a>
            </div>
          </div>


        </div>
      </div>
    </footer>
  )
}

export default Footer
